import CustomRadioButton from "../../components/buttons/CustomRadioButton";
import DynamicDropdown from "../../components/Dropdowns/DynamicDropdown";
import InputLabel from "../../components/inputfields/InputLabel";
import S3ImageUpload from "../../components/S3uploads/S3ImageUpload";
import endpoints from "../../services/endpoints";

interface PaidProps {
  formData: {
    [key: string]: any;
  };
  handleInputChange: (field: string, value: string) => void;
  notEnglish: boolean;
  errors: {
    [key: string]: string;
  };
}

export default function Paid({
  formData,
  handleInputChange,
  notEnglish,
  errors,
}: PaidProps) {
  const { bankList, regionalOffices } = endpoints;

  const handleDynamicValue = (value: any) => {
    return value.name;
  };
  return (
    <div className="w-full flex pb-4 gap-x-6">
      <div className="bg-background_blue w-[50%] rounded-lg p-4">
        <InputLabel
          labelName={"Receiver Payment Source"}
          id={"choose_bank"}
          required={true}
        />
        <CustomRadioButton
          options={[
            { id: "Bank", label: "Bank", testID: "receiver-bank" },
            { id: "Cash", label: "Cash", testID: "receiver-cash"},
            { id: "Card", label: "Card", testID: "receiver-card"},
            { id: "Mobile Money", label: "Mobile Money" },
          ]}
          selected={formData?.receiver_payment_source}
          onChange={(value: string) =>
            handleInputChange("receiver_payment_source", value)
          }
          gapClassName={"gap-x-[40px]"}
          padding="py-1"
          dir={notEnglish ? "rtl" : "ltr"}
        />
        <div className="pt-4">
          <DynamicDropdown
            apiEndPoint={`${formData.receiver_payment_source === 'Cash' ? regionalOffices : bankList}?page_number=`}
            labelName={""}
            id={"receiver_bank"}
            tabIndex={1}
            noSearch={false}
            handelDynamicValue={handleDynamicValue}
            onChange={handleInputChange}
            selectedValue={formData?.receiver_bank}
            errorMessage={errors?.receiver_bank}
            testId={"receiver_bank"}
            dropdownTestId={"receiver_bank_dropdown"}
            dropdownTopClass={"top-[65px]"}
            toolTipClassName={"-top-[1rem]"}
            placeHolderValue={
              formData.receiver_payment_source === "Cash"
                ? "regional office"
                : "bank"
            }
          />
        </div>
        {(Object.keys(formData?.receiver_bank).length !== 0 && Object.keys(formData?.receiver_bank) && formData?.receiver_bank?.charge_mode)&& (
          <p className="text-body2 text-secondary_text mt-1">
            Note:{" "}
            {`${
              formData?.receiver_bank?.charge_mode === "PERCENTAGE"
                ? `${formData?.receiver_bank?.charge_value}% bank charges associated`
                : ` Bank charges of AFA ${formData?.receiver_bank?.charge_value} will be deducted.`
            }`}
          </p>
        )}
        <S3ImageUpload
          heading=""
          label={`${formData.receiver_payment_source === 'Cash' ? 'Cash' : 'Bank'} Transfer Receipt`}
          disabled={false}
          upload_id={"transaction_receipt"}
          UploadPath={"uploads/transaction_receipt"}
          handleUpload={handleInputChange}
          uploadedFile={formData.transaction_receipt || ""}
          errorMessage={errors?.transaction_receipt}
          required={true}
          paddingTop="pt-4"
        />
      </div>
      <div className="bg-background_blue w-[50%] rounded-lg p-4" data-testid={'sender-payment-source'}>
        <InputLabel
          labelName={"Sender Payment Source"}
          id={"choose_bank"}
          required={true}
        />
        <CustomRadioButton
          options={
            formData.receiver_payment_source === "Cash"
              ? [{ id: "Cash", label: "Cash", testID: "sender-cash" }]
              : [
                  { id: "Bank", label: "Bank", testID: "sender-bank" },
                  { id: "Cash", label: "Cash", testID: "sender-cash" },
                ]
          }
          selected={formData?.sender_payment_source}
          onChange={(value: string) =>
            handleInputChange("sender_payment_source", value)
          }
          gapClassName={"gap-x-[40px]"}
          padding="py-1"
          dir={notEnglish ? "rtl" : "ltr"}
        />
        <div className="pt-4">
          <DynamicDropdown
            apiEndPoint={`${formData.sender_payment_source === 'Cash' ? regionalOffices : bankList}?user_type=SADM&page_number=`}
            labelName={""}
            id={"sender_bank"}
            tabIndex={1}
            noSearch={false}
            handelDynamicValue={handleDynamicValue}
            onChange={handleInputChange}
            selectedValue={formData?.sender_bank}
            errorMessage={errors?.sender_bank}
            testId={"sender_bank"}
            dropdownTestId={"sender_bank_dropdown"}
            dropdownTopClass={"top-[65px]"}
            toolTipClassName={"-top-[1rem]"}
            placeHolderValue={
              formData.sender_payment_source === "Cash"
                ? "regional office"
                : "bank"
            }
          />
        </div>
      </div>
    </div>
  );
}
